import React, { useEffect } from 'react'
import UploadIcon from '../Icons/outline/UploadIcon'

function FileInput({
  accept,
  handleFileUpload,
  label,
  small,
  large,
  top,
  className,
  labelClass,
  id,
  buttonText,
  right,
  resetFiles,
}) {

  const [files, setFiles] = React.useState()
  
  const onChange = (e) => {
    handleFileUpload(e);
    setFiles(e.target?.files[0].name || '');
  }

  useEffect(() => {
    if (resetFiles) setFiles(null);
  }, [resetFiles]);
  

  return (
    <>
      {label && <label id={id} className={`font-semibold text-secondary my-auto ${labelClass}`}>{label}</label>}
      <div className={`flex items-center ${top && 'flex-col'}  ${className}`} id={id}>
        {!right && <span className={`${!top &&  'mr-2'} ${top && 'mb-2'} text-center text-primary`}>
          {files}
        </span>}
        <label htmlFor='uploadFile' className={`px-4 text-secondary hover:bg-light cursor-pointer flex items-center justify-center bg-white border border-gray-300 rounded ${!large &&  'py-1.5 px-2'} ${small && 'py-3 px-2 text-sm'} ${large && 'py-3 px-2 text-lg'}`}>
          <UploadIcon />
          <span className='ml-2'>{buttonText ? buttonText : 'Upload'}</span>
        </label>
        <input type='file' id='uploadFile' className='hidden' accept={ accept ? accept : ''} onChange={onChange}/>
        {right && <span className={`ml-2 text-center text-primary`}>
          {files}
        </span>}
      </div>
    </>
  )
};

export default FileInput;